import { render } from "./SurveyRevision.vue?vue&type=template&id=aa8842fe&scoped=true"
import script from "./SurveyRevision.vue?vue&type=script&lang=js"
export * from "./SurveyRevision.vue?vue&type=script&lang=js"

import "./SurveyRevision.vue?vue&type=style&index=0&id=aa8842fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8842fe"]])

export default __exports__